module.exports = __webpack_public_path__ + "media/images/equipments-img-05-9e78549025bb50a3d8f5560eadf5eb54.png";